module.exports = __webpack_public_path__ + "static/media/savewater.c278e378.png";